import type { ChatbotBlock } from "blocks/v2/Chatbot/schema";
import { cn } from "utils/cn";
import { usePageContext } from "lib/context/page-context";
import { EditingChatbotPrompt } from "./EditingChatbotPrompt";
import { LiveChatbotPrompt } from "./LiveChatbotPrompt";
import { useDraftChatbotBlock } from "../DraftChatbotBlockContext";
import { useTrackOpenAiUsage } from "../lib/useTrackOpenAiUsage";

type ChatbotPromptProps = {
  config: ChatbotBlock["config"];
};

export function ChatbotPrompt({ config: publishedConfig }: ChatbotPromptProps) {
  const { isEditing, isThumbnail, projectId } = usePageContext();

  const draftConfig = useDraftChatbotBlock(publishedConfig.id);
  const config = isEditing && draftConfig ? draftConfig : publishedConfig;

  if (!projectId) {
    throw new Error("projectId is required");
  }

  const { trackOpenAiUsage } = useTrackOpenAiUsage(config);

  return (
    <StyledChatbot>
      {isEditing ? (
        <EditingChatbotPrompt config={config} />
      ) : (
        <LiveChatbotPrompt
          config={config}
          isDisabled={isThumbnail}
          onUsage={trackOpenAiUsage}
        />
      )}
    </StyledChatbot>
  );
}

const StyledChatbot: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"div">
> = (props) => (
  <div
    {...props}
    className={cn(
      "relative flex min-h-0 flex-col items-stretch font-sans text-zi-text",
      props.className
    )}
  />
);
